/**
 * Money display for the partner portal.
 *
 * The API hands back amounts as full-precision decimal strings ("12345.6789")
 * and a separate currency code. Every figure a partner reads is grouped,
 * prefixed with the currency code, and shown to 2 decimal places — with real
 * fee deductions (deposit/withdrawal fees, revenue share) now landing on real
 * cents, rounding to whole shillings would hide exactly the figures a partner
 * needs to reconcile against. Matches the super-admin portal's own formatKes.
 */
export function formatKes(amount, currency = "KES") {
  const n = typeof amount === "number" ? amount : Number(amount);
  if (!Number.isFinite(n)) return `${currency} 0.00`;
  return `${currency} ${n.toLocaleString("en-KE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/** For a list of {amount, currency} pairs from the API. */
export function formatCurrencyAmounts(amounts) {
  if (!amounts || amounts.length === 0) return "—";
  return amounts.map((a) => formatKes(a.amount, a.currency)).join(" · ");
}

export function formatExact(value) {
  if (value === null || value === undefined || value === "") return "—";
  const str = String(value).trim();
  const match = /^([+-]?)(\d+)(?:\.(\d+))?$/.exec(str);
  if (!match) return str;
  const [, sign, whole, fraction] = match;
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `${sign}${grouped}${fraction ? `.${fraction}` : ""}`;
}

export function formatExactInText(text) {
  if (!text) return "";
  const source = String(text);
  return source.replace(/[+-]?\d+(?:\.\d+)?/g, (token, offset) => {
    const before = source[offset - 1];
    const after = source[offset + token.length];
    if ((before && /[\w.]/.test(before)) || (after && /[\w.]/.test(after))) return token;
    return formatExact(token);
  });
}

export function humanizeKey(key) {
  if (!key) return "";
  const spaced = String(key)
    .replace(/[_-]+/g, " ")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .toLowerCase();
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
